<template>
  <div v-if="$store.state.auth.isLoggedIn">
    <v-navigation-drawer
      v-model="$store.state.navigation"
      fixed
      temporary
      style="z-index: 9999"
      app
    >
      <v-list-item style="background: #ababab">
        <v-list-item-avatar>
          <v-img :src="$store.getters.userAvatar"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            >{{ $store.state.auth.user.given_name }}
            {{ $store.state.auth.user.family_name }}</v-list-item-title
          >
          <v-list-item-title style="font-size: 12px">{{
            $store.state.auth.user.email
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list dark dense style="background: #909090">
        <v-list-item
          v-for="item1 in mainItems"
          :to="{ name: item1.link }"
          :key="item1.title"
          link
          tag="a"
        >
          <v-list-item-icon>
            <v-icon>{{ item1.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <translate>{{ item1.title }}</translate>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list dense>
        <v-list-item :to="{ name: item2.link }" v-for="item2 in sorts" :key="item2.title" link>
          <v-list-item-icon>
            <v-icon>{{ item2.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <translate>{{ item2.title }}</translate>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider style="border-width: 1px"></v-divider>
      <v-list dense>
        <v-list-item :to="{ name: item3.link }" v-for="item3 in tenderList" :key="item3.title" link>
          <v-list-item-icon>
            <v-icon>{{ item3.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <translate>{{ item3.title }}</translate>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn @click="logout" color="grey lighten-2" block>
            <translate>Log out</translate>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
  <div v-else>
    <v-navigation-drawer v-model="$store.state.navigation" absolute temporary>
      <v-list-item style="background: #ababab">
        <div class="pa-2 pb-5 ma-auto">
          <p v-translate>Please log in or register to use all the available features.</p>
          <v-btn @click="login" color="grey lighten-2" block>
            <translate>LOG IN</translate>
          </v-btn>
        </div>
      </v-list-item>
      <v-list dense>
        <v-list-item @click.prevent="navigateTo('starred')" link>
          <v-list-item-icon>
            <v-icon>grade</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <translate>Starred</translate>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider style="border-width: 1px"></v-divider>
      <v-list dense>
        <v-list-item :to="{ name: item4.link }" v-for="item4 in tenderList" :key="item4.title" link>
          <v-list-item-icon>
            <v-icon>{{ item4.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <translate>{{ item4.title }}</translate>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
// import Vue from 'vue'
// import VueCookies from 'vue-cookies'
// import ErrorParser from '@/services/helpers/ErrorParser'
// import LogOut from '@/mixins/LogOut'

export default {
  name: 'Navigation',

  props: {
    logout: {
      type: Function,
      required: true,
    },
    login: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      mainItems: [
        { title: 'Profile', icon: 'account_circle', link: 'profile' },
        // { title: 'Preferences', icon: 'work_outline' },
        {
          title: 'Organization',
          icon: 'group',
          link: 'organization',
        },
      ],
      sorts: [
        {
          title: 'My Tenders',
          icon: 'folder_shared',
          link: 'mytenders',
        },
        {
          title: 'Drafts',
          icon: 'restore_from_trash',
          link: 'drafttenders',
        },
        {
          title: 'Tenders',
          icon: 'folder_shared',
          link: 'tenders',
        },
        { title: 'Starred', icon: 'grade', link: 'starred' },
        {
          title: 'Open for Participation',
          icon: 'folder_shared',
          link: 'opentenders',
        },
        {
          title: 'My Bids',
          icon: 'folder_shared',
          link: 'mybidstenders',
        },
        {
          title: 'My Draft Bids',
          icon: 'restore_from_trash',
          link: 'mydraftbidstenders',
        },
        {
          title: 'Prozorro Tenders',
          icon: 'folder_shared',
          link: 'prozorrotenders',
        },
        // {
        //     title: 'Action required',
        //     icon: 'turned_in',
        //     link: 'tenders'
        // },
        // { title: 'Archive', icon: 'archive', link: 'tenders' }
      ],
      tenderList: [
        // { title: 'Today', icon: 'today', link: 'todayTenders' },
        // { title: 'New', icon: 'fiber_new', link: 'tenders' },
        // {
        //     title: 'Outside Quebec',
        //     icon: 'tab_unselected',
        //     link: 'tenders'
        // }
      ],
    }
  },
  created() {
    this.$gettext('Profile')
    this.$gettext('Preferences')
    this.$gettext('Organization')
    this.$gettext('Administration')
    this.$gettext('My Tenders')
    this.$gettext('Drafts')
    this.$gettext('Action required')
    this.$gettext('Archive')
    this.$gettext('Today')
    this.$gettext('Outside Quebec')
    this.$gettext('New')
    this.$gettext('text45')
  },
  methods: {
    // login() {
    //     this.$store.commit('navigation', false)
    //     this.$router.push({ name: 'login' })
    // }
    // navigateTo(link, event) {
    //     if (event && event.which === 2) {
    //         event.preventDefault()
    //         console.log('middle button click', event.target)
    //         console.log('route', this.$route)
    //         console.log('window loc', window.location)
    //         window.open(`${window.location.origin}/#/${link}`, '_blank')
    //     } else if (link) {
    //         this.$router.push({ name: link })
    //         this.$store.commit('navigation', false)
    //     }
    // }
  },
}
</script>

<style scoped>
.theme--dark.v-list-item--active:hover::before,
.theme--dark.v-list-item--active::before {
  opacity: 0.12;
}

a.v-list-item--active.theme--dark {
  color: #ffffff;
}

a.v-list-item--active.theme--light {
  color: #2c2929;
}

.v-overlay--active {
  z-index: 4 !important;
}
</style>
